import { 
  Component, 
  EventEmitter, 
  Input, 
  Output, 
  Renderer2, 
  ElementRef, 
  ViewChild, 
  OnInit, 
  OnDestroy, 
  AfterViewInit 
} from '@angular/core';

import { 
  OrderedListComponent 
} from '../ordered-list/ordered-list.component';

import {
  LabelService
} from '../../providers';

import {
  RateWms
} from '../../models';

@Component({
  selector: 'biz-wms-rates-group',
  templateUrl: './wms-rates-group.component.html',
  styleUrls: ['./wms-rates-group.component.scss']
})
export class WmsRatesGroupComponent implements OnDestroy, AfterViewInit, OnInit {
  @Input() index: number;
  @Input() label: string;
  @Input() optionMap: { [key: string]: string[] };
  @Input() disabled: boolean;
  @Input() items: RateWms[];
  @Input() itemEmpty: RateWms;
  @Input() fields: any[];
  @Input() hasSameExtraSKU: boolean = false;
  @Input() singleRateTypes: any[];
  @Input() isExtraSKUSameFlag: boolean = false;
  @Input() isSameCalculationDisabled: boolean = false;

  private hasOFPAPFlag: boolean;

  public isWMS: boolean = true;
  
  public editLabel: boolean = false;
  public isExtraSKUSame: boolean = false;
  public isExtraSKUSameDisabled: boolean = true;

  @Output() removeGroup = new EventEmitter<void>();
  @Output() editGroupItem = new EventEmitter<{ index: number, items: any[] }>();
  @Output() labelEmitter = new EventEmitter<string>();
  @Output() isExtraSKUSameChange = new EventEmitter<boolean>();

  @ViewChild('labelElement') labelElement: ElementRef;

  @ViewChild(OrderedListComponent) orderedList: OrderedListComponent;

  private globalClickListener: () => void;

  constructor(
    private renderer: Renderer2,
    private labelService: LabelService
  ) {}
  ngOnInit(): void {
    if (this.isExtraSKUSameFlag !== undefined) {
      this.isExtraSKUSame = this.isExtraSKUSameFlag;
    }
    this.checkHasOFPAP();
  }

  @Input()
  set hasOFPAP(value: boolean) {
    this.hasOFPAPFlag = value;
    this.checkHasOFPAP();
  }

  get hasOFPAP(): boolean {
    return this.hasOFPAPFlag;
  }

  ngAfterViewInit(): void {
    this.globalClickListener = this.renderer.listen(
      'window', 
      'click', 
      (event: Event) => {
        if (
          this.editLabel && 
          !this.labelElement.nativeElement.contains(event.target)
        ) {
          this.editLabel = false;
          this.label = this.labelService.generateUniqueLabel(this.label);
          this.labelEmitter.emit(this.label);
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (this.globalClickListener) {
      this.globalClickListener();
    }
  }

  onRemove(): void {
    this.removeGroup.emit();
  }

  public onToggleChange(): void {
    if (
      this.disabled ||
      this.isExtraSKUSameDisabled ||
      this.isSameCalculationDisabled
    ) {
      return;
    }

    this.isExtraSKUSame = !this.isExtraSKUSame;
    this.isExtraSKUSameChange.emit(this.isExtraSKUSame);
  }

  public onToggleEditLabel(): void {
    if (this.disabled) {
      return;
    }
    this.editLabel = true;
  }

  public getLabelValue(): string {
    return this.label;
  }

  public onLabelChange(newValue: string): void {
    this.label = newValue;
    this.labelEmitter.emit(this.label);
  }

  public onEdit(event: { index: number, items: any[] }): void {
    this.editGroupItem.emit(event);
  }

  updateItemField(
    itemIndex: number, 
    valueKey: string, 
    value: any, 
    emitEdit: boolean = false
  ): void {
    this.orderedList.updateItemField(itemIndex, valueKey, value, emitEdit);
  }

  public checkHasOFPAP(): void {
    if (!this.hasOFPAPFlag) {
      this.isExtraSKUSameDisabled = true;
      this.isExtraSKUSame = false;
    } else {
      this.isExtraSKUSameDisabled = false;
    }
  }
}